import {lazy} from "react"

export const Roles = lazy(() => import("@/views/roles/Roles"))